// extracted by mini-css-extract-plugin
export var productCardButtonWrapper = "product-card-module--productCardButtonWrapper--1a3e1";
export var productCardHeadlineWrapper = "product-card-module--productCardHeadlineWrapper--669e3";
export var productCardStyle = "product-card-module--productCardStyle--9a6be";
export var productDetailsStyle = "product-card-module--productDetailsStyle--d1c05";
export var productHeadingStyle = "product-card-module--productHeadingStyle--8708f";
export var productImageStyle = "product-card-module--productImageStyle--b5c69";
export var productPrice = "product-card-module--productPrice--c9ea5";